import { render, staticRenderFns } from "./ShowAll.vue?vue&type=template&id=80bb975e&scoped=true"
import script from "./ShowAll.vue?vue&type=script&lang=js"
export * from "./ShowAll.vue?vue&type=script&lang=js"
import style0 from "./ShowAll.vue?vue&type=style&index=0&id=80bb975e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80bb975e",
  null
  
)

export default component.exports